import React from "react";
import noJob from "../../../../assets/insight/noJobs.svg";

function NoActiveBatches({ setCreateBatchFlag }) {
  return (
    <div className="text-center mt-[4rem]">
      <img src={noJob} width={370} className="mx-auto" alt="" />
      <p className="sub-text-color mt-2 max-w-[450px] mx-auto">
        No active batches to display. Create your first batch to start managing
        candidates and interviews.
      </p>
      <button
        onClick={() => setCreateBatchFlag(true)}
        className="btn-orange mt-4 rounded-lg px-3 py-1"
      >
        + Create Batch
      </button>
    </div>
  );
}

export default NoActiveBatches;
